<template>
  <div id="content" :style="pageBgStyles">
    <div class="container">
      <h1>{{ title }}</h1>

      <div class="row">

        <swiper :options="swiperOption">
          <div class="equipments-prev" slot="button-prev"></div>
          <swiper-slide v-for="(value, key) in equipments" v-bind:key="key">
            <div class="img-wrap">
              <img :src="value.img" alt="" class="swiper-lazy">
            </div>
            <div class="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
            <div class="caption">{{ value.title }}</div>

          </swiper-slide>

        </swiper>
        <div class="equipments-next" slot="button-next"></div>
      </div>
      <p>{{ content }}</p>
    </div>
  </div>
</template>
<script>
  import { swiper, swiperSlide } from 'vue-awesome-swiper'
  import pageBgStyles from '../common/js/page-bg-styles'
  import getMeta from '../common/js/get-meta'
  export default {
    mixins: [pageBgStyles, getMeta],
    components: {
      swiper,
      swiperSlide
    },
    data () {
      return {
        title: 'Проверка топливной аппаратуры на стенде',
        image: '/static/bg3.jpg',
        content: 'Наше оборудование позволяет придерживаться заводской технологии ремонта топливной аппаратуры(если такой возможен). Для большинства случаев проверки форсунок и насосов требуется специальные стенды. Они позволяют делать точные замеры параметров топливного дизельного оборудования.',
        equipments: [
          {
            title: 'Диагностический стенд AVM2-PC',
            text: 'Универсальный диагностический стенд AVM2-PC производства Hartridge — компании -лидера в области создания стендов для диагностики и испытаний дизельной топливной аппаратуры, используется для испытаний любых компонентов выпускаемых сегодня дизельных систем: рядных и роторных механических насосов, электронных насосов, насос-форсунок, насосов Common Rail и форсунок Common Rail. Наличие стенда - обязательное условие получения авторизации по ремонту насосов марок Delphi, Denso и VDO (Siemens).',
            img: '/static/equipments/avm2-pc.jpg'
          },
          {
            title: 'Оборудование для испытаний насосов Common Rail HF1130',
            text: 'Комплект HF1130 используется для проверки и регулировки насосов Common Rail производства Bosch, Delphi, Denso и Siemens, обеспечивая уровень функциональных возможностей, до настоящего времени еще не достигнутый другими системами. Комплект работает совместно с испытательным стендом AVM2-PC (20л.с.) и базовым комплектом для Common Rail HB378.',
            img: '/static/equipments/hf1130.jpg'
          },
          {
            title: 'Оборудование для испытаний EUI/EUP (электронных насос-форсунок и насосных секций)',
            text: 'Набор оснастки HK870 позволяет проводить на стенде AVM2-PC испытания электронных насос-форсунок и индивидуальных насосов с электронным управлением (EUI & EUP). Возможности и особенности : <ul><li>Точные и подробные результаты при испытаниях EUI/EUP</li><li> Испытания EUI соленоидного и пьезо типов.</li><li> Возможность авторизованного ремонта насос-форсунок Delphi серий А и Е1 при использовании тензометрического комплекта HB388.</li><li> Авторизованный ремонт насос-форсунок Delphi E3 </li><li> Применение сменных кулачков оригинального профиля позволяет точно воссоздать на стенде работу в реальных условиях, обеспечивая самую высокую точность результатов.</li></ul>',
            img: '/static/equipments/HB378_Medium.jpg'
          },
          {
            title: 'Стенд для испытаний форсунок Common Rail',
            text: 'Специализированный стенд производства Hartridge CRi-PC предназначен для испытаний только форсунок систем Common Rail всех марок и типов. Сегодня это самый совершенный и производительный стенд своего рода, также может работать как в универсальном, так и в авторизованном Delphi режимах. В последнем случае, при работе с программным обеспечением Delphi Iris, стенд по результатам теста генерирует код c2i, а с недавнего времени c3i, необходимые для «прописки» форсунок Common Rail при установке на двигатель.',
            img: '/static/equipments/CRi_PC_Medium.jpg'
          },
          {
            title: 'Диагностический стенд Testmaster-3',
            text: 'Testmaster 3 HH701 - это испытательный стенд для проверки работоспособности форсунок, оборудованный пневматическим приводом, совершенным и гибким програмным обеспечением и жидкокристаллическим дисплеем для отображения результатов. Testmaster 3 HH701 отличается компактными размерами, прост и гибок в эксплуатации, позволяет сохранять и выводить на печать результаты испытаний при помощи внешнего ПК/принтера.',
            img: '/static/equipments/HH701_Medium.jpg'
          },
          {
            title: 'Стенд для диагностики двухпружинных форсунок 2-Stagemaster',
            text: '2 Stagemaster HH720 – экономически эффективный и простой в работе модуль для проверки двухступенчатых форсунок. HH720 используется совместно с приборами для испытания форсунок Testmaster-2 (HH700) или Testmaster-3 (HH701). 2 Stagemaster HH720 оборудован жидкокристаллическим экраном и простым автоматическим управлением для определения давления открытия второй ступени распылителя (NOP2).',
            img: '/static/equipments/HH700_Medium.jpg'
          },
          {
            title: 'Приставка для диагностики насос-форсунок EUI Poptest',
            text: 'Модель HH705 сохраняет все функциональные возможности Testmaster-3, а также дополнительно позволяет тестировать насос-форсунки. Дополнительные функции могут быть обеспечены при работе с IFT-c и приставкой 2-Stagemaster- они позволят HH705 тестировать форсунки Common Rail и двухступенчатые форсунки.',
            img: '/static/equipments/hh705-300x243.jpg'
          },
          {
            title: 'Прибор для диагностики Common Rail форсунок IFT-70',
            text: 'IFT-70 разработан для начальной диагностики форсунок Common Rail. IFT может быть использован либо как часть диагностики транспортного средства в мастерской  или как часть полной программы испытания, диагностики и ремонта форсунки при использовании в сочетании с испытательными стендами AVM или CRi-PC Hartridge. На сегодняшний день     IFT-70 представляет собой одно из лучших экономически эффективных решений для предварительной диагностики систем Common Rail',
            img: '/static/equipments/IFT70large.gif'
          },
          {
            title: 'Системы для очистки',
            text: 'Для очистки механизмов и элементов топливной аппаратуры используется ультразвуковые ванны,Microdiesel-Cabinet «Чистый шкаф» ',
            img: '/static/equipments/microdiesel.jpg'
          }
        ],
        swiperOption: {
          slidesPerView: 6,
          preloadImages: false,
          // Enable lazy loading
          lazyLoading: true,
          nextButton: '.equipments-next',
          prevButton: '.equipments-prev',
          spaceBetween: 2,
          breakpoints: {
            1024: {
              slidesPerView: 5,
              spaceBetween: 2
            },
            768: {
              slidesPerView: 4,
              spaceBetween: 2
            },
            640: {
              slidesPerView: 3,
              spaceBetween: 2
            },
            480: {
              slidesPerView: 2,
              spaceBetween: 2
            },
            320: {
              slidesPerView: 1,
              spaceBetween: 2
            }
          }
        }
      }
    }
  }

</script>
<style lang="stylus" scoped>
h1
  font-size 1.6em

.swiper-container
  margin-top 20px
  width 100%
  height 100%

.swiper-slide
  text-align center

  &:hover
    .caption
      display block
      background-color rgba(0, 0, 0, 0.96)

.swiper-slide
  img
    height 100%
    width 100%

// height 100%
// max-width 100%
// max-height 100%
.img-wrap
  height 150px
  width 100%

.caption
  position absolute
  bottom 0
  min-height 50%
  width 100%
  left 0
  font-size 13px
  font-weight 600
  display block
  background-color rgba(0, 0, 0, 0.86)

@media only screen and (min-width: 992px)
  h1
    font-size 2em
</style>



// WEBPACK FOOTER //
// Equipments.vue?548d54d7